import { useState, useCallback } from 'react';
import { userService } from '@/services/api';
import type { User, UserUpdatePayload } from '@/common-types';
import type { UseUsersReturn } from '@/types/application/common/hooks/use-users';

export function useUsers(): UseUsersReturn {
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await userService.listUsers();
      setUsers(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load users');
    } finally {
      setLoading(false);
    }
  }, []);

  const updateUser = useCallback(async (userId: string, payload: UserUpdatePayload) => {
    await userService.updateUser(userId, payload);
    await refresh();
  }, [refresh]);

  return { users, loading, error, refresh, updateUser };
}

export default useUsers;




